import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { publicApi } from '../utils/api';

// Staff invite acceptance (pkg15v2). Reads ?code=, validates it, collects the
// invitee's name + password, creates their admin_user, then points them at the
// firm's login.
const ROOT_DOMAIN = process.env.REACT_APP_ROOT_DOMAIN || 'lawmighty.com';

export default function AcceptInvitePage() {
  const [params] = useSearchParams();
  const code = params.get('code');
  const [state, setState] = useState('loading'); // loading | form | done | error
  const [info, setInfo] = useState(null); // { email, role, firm_name, subdomain }
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [bar, setBar] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!code) { setState('error'); setError('This invitation link is missing its code.'); return; }
    publicApi.validateInvite(code)
      .then((r) => { setInfo(r); setState('form'); })
      .catch((err) => { setState('error'); setError(err.message || 'This invitation is invalid or has expired.'); });
  }, [code]);

  async function submit() {
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    setSubmitting(true);
    try {
      await publicApi.acceptInvite(code, { name: name.trim(), password, bar_number: bar.trim() || null });
      setState('done');
    } catch (err) {
      setError(err.message || 'Could not accept the invitation.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-brand"><h1>Join your firm</h1></div>
        {state === 'loading' && <p style={{ textAlign: 'center', color: '#888' }}><span className="spinner" /> Loading…</p>}
        {error && (state === 'error' || state === 'form') && <div className="alert alert-error">{error}</div>}
        {state === 'form' && info && (
          <>
            <p style={{ color: '#555', marginTop: 0 }}>
              You're joining <strong>{info.firm_name}</strong> as <strong>{info.role}</strong>, with the email{' '}
              <strong>{info.email}</strong>.
            </p>
            <div className="form-group">
              <label>Your name</label>
              <input type="text" value={name} autoFocus onChange={(e) => setName(e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Choose a password</label>
              <input type="password" value={password} autoComplete="new-password"
                onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Bar number (optional)</label>
              <input type="text" value={bar} onChange={(e) => setBar(e.target.value)} />
            </div>
            <button className="btn btn-primary btn-block" disabled={submitting || !name.trim() || !password} onClick={submit}>
              {submitting ? <><span className="spinner" />Joining…</> : 'Accept invitation'}
            </button>
          </>
        )}
        {state === 'done' && info && (
          <>
            <div className="alert alert-success">Your account is ready. Sign in with <strong>{info.email}</strong>.</div>
            <a className="btn btn-primary btn-block" href={`https://${info.subdomain}.${ROOT_DOMAIN}/admin`}>
              Go to {info.subdomain}.{ROOT_DOMAIN}
            </a>
          </>
        )}
      </div>
    </div>
  );
}
